function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './HeroPrimary.css';
import React, { useState, useEffect, useRef, useMemo } from 'react';
import { canUseDOM, get, getColorByTheme, getPageThemeColors, injectImageResolution } from '../../utils';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import RouterLink from '../atoms/RouterLink';
import { useHistory } from 'react-router-dom';
import { ReactComponent as IconPlaySharedCh } from '../../resources/icons/IconPlaySharedCh.svg';
import { convertToAnalyticObject } from '../../utils/analytics';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { ReactComponent as IconDblArrowDown } from '../../resources/icons/IconDblArrowDown.svg';
import { ReactComponent as IconChevronRight } from '../../resources/icons/chevron-bold.svg';
import Video from '../atoms/Video';
import { isNil } from '../../utils/IsNil';
import { stylesOldCarousel } from '../../utils/OldCarouselDotsStyles';
import { useVideoModal } from '../atoms/VideoModal/VideoModal';
import { RenderVideo } from '../atoms/VideoModal/RenderVideo';
const HeroPrimary = props => {
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const {
    fields,
    params
  } = props;
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const heroWrapperRef = useRef(null);
  const slides = get(fields, 'data.item.children', []);
  const [videoTeaserAutoPlay, setVideoTeaserAutoPlay] = useState(true);
  const [carouselAutoplay, setCarouselAutoplay] = useState(true);
  const [iconplay, setIconPlay] = React.useState(true);
  const [isTablet, setIsTablet] = React.useState(false);
  const [activeBannerTitle, setActiveBannerTitle] = React.useState('');
  const [isVdsite, setIsVdsite] = useState(true);
  const [navbarHeightStyle, setNavbarHeightStyle] = useState({});
  const history = useHistory();
  const firstTime = useRef(true);
  const checkIsTablet = () => {
    const condition = canUseDOM && window.innerWidth <= 992;
    setIsTablet(condition);
  };
  React.useEffect(() => {
    if (canUseDOM) {
      window.addEventListener('resize', checkIsTablet);
      const interval = setInterval(checkIsTablet, 1000);
      return () => {
        window.removeEventListener('resize', checkIsTablet);
        clearInterval(interval);
      };
    }
  }, []);
  const actualSSR = process.env.STORYBOOK_MODE ? false : sitecoreContext.route && sitecoreContext.route.fromSSR;
  const isMobile = useMemo(() => {
    return !actualSSR && canUseDOM && window.matchMedia(`(max-width: 991px)`).matches;
  }, [actualSSR]);
  useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  useEffect(() => {
    if (canUseDOM) {
      const header = document.querySelector('header');
      setNavbarHeightStyle({
        '--navbar-height': header ? `${header.offsetHeight}px` : '0px'
      });
    }
  }, []);
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const isSharedCh = get(params, 'RenderingStyle') === 'Shared Channels' || false;
  const {
    modalVideoState,
    setModalVideoState,
    isShown,
    toggle,
    checkMouseMoved,
    startOnce,
    setStartOnce
  } = useVideoModal();
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ColorHex = get(params, 'ColorHex');
  const ActiveColorHex = get(params, 'ActiveColorHex');
  const carouselSpeed = get(params, 'timeout');
  const timing = carouselSpeed ? Number(carouselSpeed) * 1000 : 7000;
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  const variables = BackgroundColorHex ? {
    '--m57-hero-primary-background-color': BackgroundColorHex,
    '--m57-hero-primary-background-active-color': ActiveColorHex,
    '--m57-hero-primary-color': ColorHex
  } : {
    '--m57-hero-primary-background-color': selectedPrimaryColor,
    '--m57-hero-primary-background-active-color': primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    '--m57-hero-primary-color': getColorByTheme(selectedPrimaryColor)
  };
  Object.assign(variables, {
    '--m113-interactive-banner-timing': `${timing / 1000}s`,
    '--m113-interactive-banner-half-timing': `${timing / 1000 / 2}s`
  });
  if (!fields) {
    console.info('Hero component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [Hero component is empty: please provide data source]");
    }
    return null;
  }
  const anchorHandler = (anchor, primaryCtaHref) => {
    if (isNil(anchor) || anchor.trim() === '') {
      return;
    }
    if (history.location.pathname.toLocaleLowerCase().includes(primaryCtaHref.split('#')[0].toLocaleLowerCase())) {
      setTimeout(() => {
        const anchorElement = document.querySelector(`[data-anhor=${anchor}]`);
        anchorElement && anchorElement.scrollIntoView({
          behavior: 'smooth'
        });
        setTimeout(() => {
          const anchorElement = document.querySelector(`[data-anhor=${anchor}]`);
          anchorElement && anchorElement.scrollIntoView({
            behavior: 'smooth'
          });
          if (firstTime.current) {
            setTimeout(() => {
              if (Math.abs(anchorElement.getBoundingClientRect().y) > 5) {
                anchorElement && anchorElement.scrollIntoView({
                  behavior: 'smooth'
                });
              }
            }, 1000);
            firstTime.current = false;
          }
        }, 200);
      }, 200);
    } else return;
  };
  const renderItems = () => slides.map(slide => {
    const src = get(slide, 'image.jss.value.src', '');
    const alt = get(slide, 'image.jss.value.alt', '');
    const title = get(slide, 'title.jss');
    const hasTitle = get(slide, 'title.jss.value');
    const intro = get(slide, 'description.jss');
    const hasIntro = get(slide, 'description.jss.value');
    const primaryCtaHref = get(slide, 'cTALink.jss.value.href');
    const primaryCtaLabel = get(slide, 'cTALinkLabel.jss.value');
    const primaryCtaTarget = get(slide, 'cTALink.jss.value.target');
    const primaryCtaLinktype = get(slide, 'cTALink.jss.value.linktype');
    const primaryCtaLinkAnchor = get(slide, 'cTALink.jss.value.anchor');
    const primaryCtaLinkLeftIcon = get(slide, 'ctaLeftIcon.targetItem.svg.jss.value');
    const primaryCtaLinkRightIcon = get(slide, 'ctaRightIcon.targetItem.svg.jss.value');
    const secondaryCtaHref = get(slide, 'cTASecondaryLink.jss.value.href');
    const secondaryCtaLabel = get(slide, 'cTASecondaryLinkLabel.jss.value');
    const secondaryCtaTarget = get(slide, 'cTASecondaryLink.jss.value.target');
    const secondaryCtaLinktype = get(slide, 'cTASecondaryLink.jss.value.linktype');
    const secondaryCtaLinkAnchor = get(slide, 'cTASecondaryLink.jss.value.anchor');
    const secondaryCtaLinkLeftIcon = get(slide, 'ctaSecondaryLeftIcon.targetItem.svg.jss.value');
    const secondaryCtaLinkRightIcon = get(slide, 'ctaSecondaryRightIcon.targetItem.svg.jss.value');
    const videoSrc = get(slide, 'video.jss.value.href', '');
    const videoType = get(slide, 'video.jss.value.linktype');
    const modalVideoDesk = get(slide, 'secondaryVideoLink.jss.value', {});
    const modalVideoMobile = get(slide, 'secondaryMobileVideoLink.jss.value', {});
    const hasPrimaryLink = primaryCtaHref && primaryCtaLabel;
    const hasSecondaryLink = secondaryCtaLabel && (secondaryCtaHref || modalVideoDesk.linktype || modalVideoMobile.linktype);
    const renderPrimary = className => {
      return /*#__PURE__*/React.createElement(RouterLink, {
        href: primaryCtaHref,
        className: className,
        title: primaryCtaLabel,
        linksTarget: primaryCtaTarget,
        linktype: primaryCtaLinktype,
        isSharedCh: isSharedCh,
        ctaLeftIcon: primaryCtaLinkLeftIcon,
        ctaRightIcon: primaryCtaLinkRightIcon,
        onClick: () => {
          tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['ctaButtonAnalytics'], params), [hasTitle, primaryCtaLabel]);
          anchorHandler(primaryCtaLinkAnchor, primaryCtaHref);
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "btn__text-wrapper"
      }, primaryCtaLabel));
    };
    const renderSecondary = () => {
      if ((modalVideoDesk.linktype || modalVideoMobile.linktype) && !isSharedCh) {
        return /*#__PURE__*/React.createElement("button", {
          className: "btn btn-secondary-mono btn--iconed",
          onClick: () => {
            tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['ctaButtonAnalytics'], params), [hasTitle, secondaryCtaLabel]);
            let finalVideo;
            if (isMobile) {
              finalVideo = modalVideoMobile.linktype ? modalVideoMobile : modalVideoDesk;
            } else {
              finalVideo = modalVideoDesk.linktype ? modalVideoDesk : modalVideoMobile;
            }
            setModalVideoState(_objectSpread(_objectSpread({}, modalVideoState), {}, {
              type: finalVideo.linktype,
              src: finalVideo.href,
              title: hasTitle
            }));
            toggle();
            setCarouselAutoplay(false);
          }
        }, secondaryCtaLinkLeftIcon ? /*#__PURE__*/React.createElement("span", {
          dangerouslySetInnerHTML: {
            __html: secondaryCtaLinkLeftIcon
          },
          className: "ctaLeftIcon"
        }) : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement("span", {
          className: "btn__text-wrapper"
        }, secondaryCtaLabel), secondaryCtaLinkRightIcon ? /*#__PURE__*/React.createElement("span", {
          dangerouslySetInnerHTML: {
            __html: secondaryCtaLinkRightIcon
          },
          className: "ctaRightIcon"
        }) : /*#__PURE__*/React.createElement(React.Fragment, null));
      }
      if ((modalVideoDesk.linktype || modalVideoMobile.linktype) && isSharedCh) {
        return null;
      }
      return /*#__PURE__*/React.createElement(RouterLink, {
        href: secondaryCtaHref,
        className: "btn btn-secondary-mono",
        title: secondaryCtaLabel,
        linksTarget: secondaryCtaTarget,
        linktype: secondaryCtaLinktype,
        isSharedCh: isSharedCh,
        ctaLeftIcon: secondaryCtaLinkLeftIcon,
        ctaRightIcon: secondaryCtaLinkRightIcon,
        onClick: () => {
          tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['ctaButtonAnalytics'], params), [hasTitle, secondaryCtaLabel]);
          anchorHandler(secondaryCtaLinkAnchor, secondaryCtaHref);
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "btn__text-wrapper"
      }, secondaryCtaLabel));
    };
    return /*#__PURE__*/React.createElement("div", {
      className: `item-wrapper ${pageEditing ? iteminEEStyles : ''}`
    }, /*#__PURE__*/React.createElement("picture", null, /*#__PURE__*/React.createElement("source", {
      media: "(min-width: 992px)",
      srcSet: `${injectImageResolution(src, 1920, 888)}`
    }), /*#__PURE__*/React.createElement("source", {
      media: "(min-width: 768px)",
      srcSet: `${injectImageResolution(src, 1024, 474)}`
    }), /*#__PURE__*/React.createElement("img", {
      src: `${injectImageResolution(src, 750, 1164)}`,
      alt: alt,
      className: "slider__image"
    })), videoSrc && videoType && /*#__PURE__*/React.createElement(Video, {
      buttonTopAlignment: true,
      videoSrc: videoSrc,
      videoType: videoType,
      click: e => tealiumClickFunc(params, `${e}: ${videoSrc}`),
      muted: true,
      autoplay: videoTeaserAutoPlay,
      videoFullHeight: true,
      isSharedCh: isSharedCh,
      hero: isSharedCh
    }), (modalVideoDesk.linktype || modalVideoMobile.linktype) && isSharedCh && /*#__PURE__*/React.createElement("span", {
      className: "btn__icon--desktop",
      onClick: () => {
        tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['ctaButtonAnalytics'], params), [hasTitle, secondaryCtaLabel]);
        let finalVideo;
        if (isMobile) {
          finalVideo = modalVideoMobile.linktype ? modalVideoMobile : modalVideoDesk;
        } else {
          finalVideo = modalVideoDesk.linktype ? modalVideoDesk : modalVideoMobile;
        }
        setModalVideoState(_objectSpread(_objectSpread({}, modalVideoState), {}, {
          type: finalVideo.linktype,
          src: finalVideo.href,
          title: hasTitle
        }));
        toggle();
        setCarouselAutoplay(false);
      }
    }, /*#__PURE__*/React.createElement(IconPlaySharedCh, null)), /*#__PURE__*/React.createElement("div", {
      className: "texts"
    }, hasTitle && /*#__PURE__*/React.createElement(Text, {
      tag: "h1",
      className: "title",
      field: title
    }), hasIntro && /*#__PURE__*/React.createElement(Text, {
      tag: "p",
      className: "intro",
      field: intro
    }), (modalVideoDesk.linktype || modalVideoMobile.linktype) && isSharedCh ? /*#__PURE__*/React.createElement("span", {
      className: "btn__icon--mobile",
      onClick: () => {
        tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['ctaButtonAnalytics'], params), [hasTitle, secondaryCtaLabel]);
        let finalVideo;
        if (isMobile) {
          finalVideo = modalVideoMobile.linktype ? modalVideoMobile : modalVideoDesk;
        } else {
          finalVideo = modalVideoDesk.linktype ? modalVideoDesk : modalVideoMobile;
        }
        setModalVideoState(_objectSpread(_objectSpread({}, modalVideoState), {}, {
          type: finalVideo.linktype,
          src: finalVideo.href,
          title: hasTitle
        }));
        toggle();
        setCarouselAutoplay(false);
      }
    }, /*#__PURE__*/React.createElement(IconPlaySharedCh, null)) : /*#__PURE__*/React.createElement("div", {
      className: "empty-Place-play-btn"
    }), /*#__PURE__*/React.createElement("div", {
      className: "btns-wrapper"
    }, hasPrimaryLink && renderPrimary(hasSecondaryLink ? 'btn btn-secondary-lokalized' : 'btn btn-secondary-mono'), hasSecondaryLink && renderSecondary()), (slides.length > 1 || get(slides[0], 'video.jss.value.href', '')) && isSharedCh && /*#__PURE__*/React.createElement("div", {
      className: "empty-Place"
    })));
  });
  const handleAutoPlay = () => {
    setCarouselAutoplay(a => !a);
    setIconPlay(a => !a);
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['navigationPlayAnalytics'], params), [`${carouselAutoplay ? 'pause' : 'play'}`, activeBannerTitle]);
  };
  const autoplayBtn = () => {
    return slides.length > 1 || get(slides[0], 'video.jss.value.href', '') ? /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: `m113-interactive-banner__autoplay ${slides.length === 1 && get(slides[0], 'video.jss.value.href', '') && 'autoplaySingle'} ${!iconplay && 'paused'} ${isTablet ? 'tablet' : ''}`,
      onClick: () => {
        setVideoTeaserAutoPlay(!videoTeaserAutoPlay);
        handleAutoPlay();
      }
    }, /*#__PURE__*/React.createElement("div", {
      id: "container"
    }, /*#__PURE__*/React.createElement("div", {
      className: `icon ${!iconplay && 'paused'}`
    }), iconplay ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      id: "halfclip"
    }, /*#__PURE__*/React.createElement("div", {
      className: "halfcircle",
      id: "clipped"
    })), /*#__PURE__*/React.createElement("div", {
      className: "halfcircle",
      id: "fixed"
    })) : /*#__PURE__*/React.createElement(React.Fragment, null))) : /*#__PURE__*/React.createElement(React.Fragment, null);
  };
  const scroolToElement = () => {
    if (heroWrapperRef.current) {
      window.scrollTo({
        top: window.scrollY + heroWrapperRef.current.getBoundingClientRect().bottom,
        behavior: 'smooth'
      });
    }
  };
  const handleSetActiveItem = state => {
    if (slides[state.currentSlide]) {
      const currentSlideTitle = slides[state.currentSlide].title.jss.value;
      setActiveBannerTitle(currentSlideTitle);
    }
  };
  const commonStyles = isSharedCh ? "c1cpmtbu" : "car8tqu";
  const ltrStyles = isSharedCh ? "l7u1w5q" : "l1uhhlzl";
  const rtlStyles = isSharedCh ? "r1ogasw4" : "r1weg37b";
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: params['Anchor Url Parameter'],
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles} ${isSharedCh && stylesOldCarousel}`,
    style: _objectSpread(_objectSpread({}, variables), navbarHeightStyle),
    fullWidth: !isSharedCh
  }, pageEditing ? () => renderItems() : () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: `hero ${slides.length === 1 ? 'react-multi-carousel-item' : ''}`,
    ref: heroWrapperRef
  }, isSharedCh ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: `mouse mouse-1 ${slides.length > 1 || get(slides[0], 'video.jss.value.href', '') ? 'mouse-carousel' : ''}`,
    onClick: scroolToElement
  }), slides.length === 1 && get(slides[0], 'video.jss.value.href', '') && autoplayBtn()) : /*#__PURE__*/React.createElement("button", {
    className: "slide-down-btn",
    "aria-label": "slide down button",
    onClick: scroolToElement
  }, /*#__PURE__*/React.createElement(IconDblArrowDown, {
    className: ""
  })), slides.length === 1 ? renderItems() : /*#__PURE__*/React.createElement(CarouselProvider, {
    handleCustomAfterChange: data => handleSetActiveItem(data)
  }, _ref => {
    let {
      renderCarousel,
      renderPreviousButton,
      renderNextButton,
      renderDots
    } = _ref;
    return /*#__PURE__*/React.createElement(React.Fragment, null, renderCarousel(renderItems(), {
      responsive: {
        desktop: {
          breakpoint: {
            max: 10000,
            min: 1024
          },
          items: 1
        },
        mobile: {
          breakpoint: {
            max: 1023,
            min: 0
          },
          items: 1
        }
      },
      autoPlay: carouselAutoplay,
      autoPlaySpeed: timing,
      pauseOnHover: !isSharedCh,
      infinite: slides.length !== 1
    }, () => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['mobileSlidesAnalytics'], params))), isSharedCh ? /*#__PURE__*/React.createElement(React.Fragment, null, slides.length === 1 ? /*#__PURE__*/React.createElement(React.Fragment, null) : /*#__PURE__*/React.createElement("div", {
      className: `m113-interactive-banner__carousel__controls-sec ${rtl ? 'btn-group-rtl' : ''}`
    }, /*#__PURE__*/React.createElement("div", {
      className: "m113-interactive-banner__carousel-btn-left"
    }, renderPreviousButton(() => {
      if (carouselAutoplay) {
        setIconPlay(false);
        setTimeout(() => {
          setIconPlay(true);
        }, 0);
      }
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['nextPrevAnalytics'], params), 'Previous');
    }, false, true, null, false, true)), autoplayBtn(), /*#__PURE__*/React.createElement("div", {
      className: "m113-interactive-banner___pagination-dots"
    }, renderDots(() => {
      if (carouselAutoplay) {
        setIconPlay(false);
        setTimeout(() => {
          setIconPlay(true);
        }, 0);
      }
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['navBubblesAnalytics'], params));
    })), /*#__PURE__*/React.createElement("div", {
      className: "m113-interactive-banner__carousel-btn-right"
    }, renderNextButton(() => {
      if (carouselAutoplay) {
        setIconPlay(false);
        setTimeout(() => {
          setIconPlay(true);
        }, 0);
      }
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['nextPrevAnalytics'], params), 'Next');
    }, false, true, null, false, true)))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "hero-carousel__control my-icon-white--mono hero-carousel__control--prev d-none d-md-block"
    }, renderPreviousButton(() => {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['nextPrevAnalytics'], params), 'Previous');
    }, true, false, /*#__PURE__*/React.createElement(IconChevronRight, {
      className: "icon"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "hero-carousel__control my-icon-white--mono hero-carousel__control--next d-none d-md-block"
    }, renderNextButton(() => {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['nextPrevAnalytics'], params), 'Next');
    }, true, false, /*#__PURE__*/React.createElement(IconChevronRight, {
      className: "icon"
    }))), renderDots(() => {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['navBubblesAnalytics'], params));
    }, slides.map(slide => ({
      title: get(slide, 'title.jss.value'),
      thumbUrl: injectImageResolution(get(slide, 'image.jss.value.src', ''), 143, 80),
      thumbAlt: get(slide, 'image.jss.value.alt', '')
    })))));
  })), /*#__PURE__*/React.createElement(RenderVideo, {
    modalVideoState: modalVideoState,
    isSharedCh: isSharedCh,
    isShown: isShown,
    setModalVideoState: setModalVideoState,
    toggle: toggle,
    checkMouseMoved: checkMouseMoved,
    startOnce: startOnce,
    setStartOnce: setStartOnce
  })));
};
const iteminEEStyles = "ijktdhl";
export default HeroPrimary;